<app-traitement-data titre="EPAP - IPAP" [sousTitre]="patient!.tableauDeBord?.epap?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.epap?.value && patient!.tableauDeBord?.epap?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.epap?.value ?? 'Ø' }} -
    {{ patient!.tableauDeBord?.ipap?.value ?? 'Ø' }}
</app-traitement-data>